import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { ClickAwayListener, Grid, IconButton, Popover } from '@mui/material';
import { useState } from 'react';
import { LuBuilding, LuMapPin } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { WsColors, WsIconText, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { formatLocation } from '../../../../features/jobsCrm/components/helper/JobsCrmHelper';
import { IEmailCampaignLog } from '../../hooks/useGetEmailCampaignLogs';

export const JobInfoDialog = ({ emailCampaign }: { emailCampaign: IEmailCampaignLog }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setOpen(false);

  const viewJobInfo = () => setOpen(true);

  const handlePopoverOpen = (event) => setAnchorEl(event?.currentTarget);

  const handleJobNavigation = () =>
    navigate(`/jobs-crm/${emailCampaign.jobId}/false/0/smartSource`);

  const handleClientNavigation = () =>
    navigate(`/client-details?clientId=${emailCampaign?.clientId}&isChild=true`);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <>
        <IconButton
          onClick={(event) => {
            viewJobInfo();
            handlePopoverOpen(event);
          }}
          sx={{ p: 0, color: WsColors.TheBlues400 }}
        >
          <InfoIcon sx={{ height: 20, width: 20 }} />
        </IconButton>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              width: 550,
              borderRadius: 8,
            },
          }}
        >
          <Grid p={2}>
            <Grid
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <WsTypography
                  variant={WsTypoVariants.TITLE}
                  color={WsTypoColors.PRIMARY600}
                  cursor="pointer"
                  onClick={handleJobNavigation}
                >{`${emailCampaign.jobTitle}  (${emailCampaign.jobCode})`}</WsTypography>
              </Grid>

              <Grid item>
                <IconButton onClick={handleClose} sx={{ padding: 0 }}>
                  <CloseIcon sx={{ fill: WsColors.GreyBlack, height: 18, width: 18 }} />
                </IconButton>
              </Grid>
            </Grid>
            <Grid p={2} container rowGap={1}>
              <Grid container alignItems="center">
                <Grid xs={4} item>
                  <WsIconText
                    icon={<LuMapPin />}
                    text="Job Location"
                    textSize={WsTypoVariants.SUB_TITLE}
                  />
                </Grid>
                <Grid item xs={8}>
                  <WsTypography variant={WsTypoVariants.SUB_TITLE}>
                    {emailCampaign?.locations?.[0]
                      ? formatLocation(emailCampaign.locations[0])
                      : 'Not Available'}
                  </WsTypography>
                </Grid>
              </Grid>
              <Grid container alignItems="center">
                <Grid xs={4} item>
                  <WsIconText
                    icon={<LuBuilding />}
                    text="Client Name"
                    textSize={WsTypoVariants.SUB_TITLE}
                  />
                </Grid>
                <Grid item xs={8}>
                  <WsTypography
                    variant={WsTypoVariants.SUB_TITLE}
                    color={WsTypoColors.PRIMARY600}
                    cursor="pointer"
                    onClick={handleClientNavigation}
                  >
                    {emailCampaign.companyName}
                  </WsTypography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Popover>
      </>
    </ClickAwayListener>
  );
};
